<template>
    <app-popover position="bottom-left" class="date-range-select">
        <template #default="{toggle}">
            <div class="rangepreviewdiv">
                <span class="date-table-header">
                    <slot>
                        <span>Datum</span>
                    </slot>
                    <span v-interact="toggle" class="icon-interact font-size-18">
                        <i aria-hidden="true" class="material-icons" role="img">search</i>
                    </span>
                </span>
                <small v-if="selectedRange" class="text-overflow rangepreview" @click="toggle">{{previewranges[selectedRange]}}</small>
            </div>
        </template>
        <template #container class="bottom-left">
            <ul v-if="selectedRange !== 'individual'" class="timelist font-weight-400">
                <li v-for="(label, key) in ranges" @click="setRange(key)" class="date-range-option" :class="{'checked background-selected': selectedRange === key}">
                    <div class="portuna-radio-button" :class="{'checked checkbox-selected': selectedRange === key}">
                        <span class="portuna-radio-button-outer" :class="{'color-primary checkbox-selected': selectedRange === key}"></span>
                        <span class="portuna-radio-button-inner" :class="{'color-primary checkbox-selected': selectedRange === key}"></span>
                    </div>
                    {{label}}
                </li>
            </ul>
            <div v-else>
                <div class="color-primary" @click="setRange('')">
                    <div class="date-range-spacer">
                        <i class="material-icons md-18" aria-hidden="true" role="img">keyboard_arrow_left</i>
                        Zurück zur Auswahl
                    </div>
                </div>

                <hr class="no-margin"/>

                <div class="date-range-spacer font-weight-300">
                    <i class="material-icons color-primary font-size-18" aria-hidden="true" role="img">check_box</i>
                    {{ranges.individual}}
                </div>

                <hr class="no-margin"/>

                <div class="date-range-spacer">
                    <div class="flex">
                        <form-row label="Start" class="rangestart range-label-spacer" required>
                            <form-input-date v-model="individualRange.start" :max="individualRange.end || null"/>
                        </form-row>

                        <form-row label="Ende" class="range-label-spacer">
                            <form-input-date v-model="individualRange.end" :min="individualRange.start || null"/>
                        </form-row>
                    </div>
                    <div class="button button-secondary" :class="{disabled: !enableIndividualApply}" @click="update">Übernehmen</div>
                </div>
            </div>
        </template>
    </app-popover>
</template>

<script setup lang="ts">
    import AppPopover from './AppPopover.vue';
    import FormInputDate from './form/FormInputDate.vue';
    import FormRow from './form/FormRow.vue';
    import {ref, reactive, computed} from 'vue';

    const emit                  = defineEmits<{
        'update:modelValue': [
            _payload2: {
                range: string;
                start: string;
                end: string;
            },
        ];
    }>();
    const props                 = withDefaults(
        defineProps<{
            modelValue: SearchDefinition;
            SubjectPlural?: string;
        }>(),
        {
            SubjectPlural: 'Eintr\u00E4ge',
        },
    );
    const selectedRange         = ref<string>('');
    const previewranges         = reactive<Record<string, string>>({
        today: 'Heute',
        next_month: '...nächsten 30 Tage',
        next_year: '...nächsten 12 Monate',
        all_future: 'alle zukünftigen',
        last_month: '...vergangenen 30 Tage',
        last_year: '...vergangenen 12 Monate',
        all_past: 'alle vergangenen',
        all: 'alle',
        individual: 'individueller Zeitraum',
    });
    const individualRange       = reactive<Record<string, string>>({});
    const enableIndividualApply = computed(() =>
    {
        return !!individualRange.start;
    });
    const ranges                = computed((): Record<string, string> =>
    {
        return {
            today: 'Heute',
            next_month: props.SubjectPlural + ' der nächsten 30 Tage',
            next_year: props.SubjectPlural + ' der nächsten 12 Monate',
            all_future: 'alle zukünftigen ' + props.SubjectPlural,
            last_month: props.SubjectPlural + ' der vergangenen 30 Tage',
            last_year: props.SubjectPlural + ' der vergangenen 12 Monate',
            all_past: 'alle vergangenen ' + props.SubjectPlural,
            all: 'alle ' + props.SubjectPlural,
            individual: 'individueller Zeitraum',
        };
    });
    const update                = () =>
    {
        emit('update:modelValue', {
            range: selectedRange.value,
            start: individualRange.start,
            end: individualRange.end,
        });
    };
    const setRange              = (rangeKey: string) =>
    {
        selectedRange.value = rangeKey;
        update();
    };
</script>